var exports = {
  "k": "xcc377c0b--c806e3--container",
};

module.exports = exports;
